import { baseUrl } from './constants/common';
import { getRouteName } from './utils/helper';
import axios from 'axios';

axios.defaults.withCredentials = true;

const API_BASE = `${baseUrl}/api/analytics`;

const setmixpanelUserId = (userId) => {
  localStorage.setItem('mixpanelUserIdKey', userId)
}

const getmixpanelUserId = () => {
  return localStorage.getItem('mixpanelUserIdKey')
}
export const identifyUser = async (user) => {
  if (!user || !user.id) {
    console.error('User object is required to identify.');
    return;
  }

  try {
    // Send user payload to backend; Laravel handles mixpanel.identify and people.set
    setmixpanelUserId(user.id)
    await axios.post(`${API_BASE}/identify`, { user });
  } catch (error) {
    console.error('Mixpanel Identify Error:', error);
  }
};

export const trackRouteChange = async (pathname) => {
  // Assuming you still use your local helper to parse names
  const routeName = getRouteName(pathname); 

  if (routeName) {
    try {
      await axios.post(`${API_BASE}/track`, {
        event_type: 'route',
        route_name: routeName,
        pathname: pathname,
        userId: getmixpanelUserId()
      });
    } catch (error) {
      console.error('Mixpanel Route Track Error:', error);
    }
  }
};

export const trackFilterChange = async (filters) => {
  try {
    await axios.post(`${API_BASE}/track`, {
      event_type: 'filter',
      filters: filters,
      userId: getmixpanelUserId()
    });
  } catch (error) {
    console.error('Mixpanel Filter Track Error:', error);
  }
};

export const trackClickEvent = async (eventName = 'Button Clicked', additionalData = {}) => {
  try {
    console.log('userid', getmixpanelUserId())
    await axios.post(`${API_BASE}/track`, {
      event_type: 'click',
      event_name: eventName,
      additional_data: additionalData,
      userId: getmixpanelUserId()
    });
  } catch (error) {
    console.error('Mixpanel Click Track Error:', error);
  }
};

export const resetMixpanel = async () => {
  try {
    await axios.post(`${API_BASE}/logout`);
  } catch (error) {
    console.error('Mixpanel Logout Error:', error);
  }
};

